import script from "./ds.policies.tab.vue?vue&type=script&setup=true&lang=ts"
export * from "./ds.policies.tab.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__